import { Injectable } from '@angular/core';
import { AngularFireAuth } from '@angular/fire/auth';
import { Router } from '@angular/router';
import { Observable, of } from 'rxjs';
import { first, switchMap } from 'rxjs/operators';

import { getFirebaseBackend } from '../../authUtils';

import { User } from '../models/auth.models';
import { DbService } from './db.service';

@Injectable({ providedIn: 'root' })
export class AuthenticationService {
  user: User;
  user$: Observable<any>;
  constructor(public afAuth: AngularFireAuth, public db: DbService, public router: Router) {
    this.user$ = this.afAuth.authState.pipe(switchMap(user => (user ? db.doc$(`users/${user.uid}`) : of(null))));
    this.handleRedirect();
  }

  getUser(): Promise<any> {
    return this.user$.pipe(first()).toPromise();
  }

  public async handleRedirect(): Promise<any> {
    if (Boolean(this.isRedirect())) {
      return null;
    }
  }

  isRedirect(): any {
    return localStorage.getItem('authRedirect');
  }

  /**
   * Returns the current user
   */
  public currentUser(): User {
    return getFirebaseBackend().getAuthenticatedUser();
  }

  /**
   * Performs the auth
   * @param email email of user
   * @param password password of user
   */
  login(email: string, password: string) {
    return getFirebaseBackend()
      .loginUser(email, password)
      .then((response: any) => {
        const user = response;
        return user;
      });
  }

  /**
   * Performs the register
   * @param email email
   * @param password password
   */
  register(email: string, password: string) {
    return getFirebaseBackend()
      .registerUser(email, password)
      .then((response: any) => {
        const user = response;
        return user;
      });
  }

  /**
   * Reset password
   * @param email email
   */
  resetPassword(email: string) {
    return getFirebaseBackend()
      .forgetPassword(email)
      .then((response: any) => {
        const message = response.data;
        return message;
      });
  }

  /**
   * Logout the user
   */
  logout() {
    // logout the user
    getFirebaseBackend().logout();
  }
}
